/*global window*/
const visitorDataKey = 'wix-visitor-data-key';
const getVisitingDataKey = instanceId => `${visitorDataKey}-${instanceId}`;

export const loadVisitorData = instanceId => {
  try {
    let visitorData = window.localStorage.getItem(visitorDataKey);
    if (visitorData !== null) {
      window.localStorage.removeItem(visitorDataKey);
      window.localStorage.setItem(getVisitingDataKey(instanceId), visitorData);
    } else {
      visitorData = window.localStorage.getItem(getVisitingDataKey(instanceId));
    }
    return (visitorData === null ? undefined : JSON.parse(visitorData));
  } catch (err) {
    console.log('Error retrieving from localStorage', err);
    return undefined;
  }
};


export const saveVisitorData = (data, instanceId) => {
  try {
    const serializedData = JSON.stringify(data);
    window.localStorage.setItem(getVisitingDataKey(instanceId), serializedData);
  } catch (err) {
    console.log('Opps, could not save data', err);
  }
};



// WEBPACK FOOTER //
// ./chat-app/services/persistence.js